 	// install a JSONP callback for chunk loading
 	var parentJsonpFunction = window["webWeddingJsonpFunction"];
 	window["webWeddingJsonpFunction"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [], result;
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
 		while(resolves.length) {
 			resolves.shift()();
 		}
 		if(executeModules) {
 			for(i=0; i < executeModules.length; i++) {
 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
 			}
 		}
 		return result;
 	};

 	// The module cache
 	var installedModules = {};

 	// objects to store loaded and loading chunks
 	var installedChunks = {
 		55: 0
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData === 0) {
 			return new Promise(function(resolve) { resolve(); });
 		}

 		// a Promise means "currently loading".
 		if(installedChunkData) {
 			return installedChunkData[2];
 		}

 		// setup Promise in chunk cache
 		var promise = new Promise(function(resolve, reject) {
 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
 		});
 		installedChunkData[2] = promise;

 		// start chunk loading
 		var head = document.getElementsByTagName('head')[0];
 		var script = document.createElement('script');
 		script.type = 'text/javascript';
 		script.charset = 'utf-8';
 		script.async = true;
 		script.timeout = 120000;

 		if (__webpack_require__.nc) {
 			script.setAttribute("nonce", __webpack_require__.nc);
 		}
 		script.src = __webpack_require__.p + "static/js/" + ({"0":"WeddingsLP","1":"Addressing","2":"DigitalPreviewPage","3":"DigitalViewCard","4":"HomeInvitation","5":"CardDetailPage","6":"CardListingPage","7":"Registry","8":"CollectAddressV2","9":"CollectAddresses","10":"Recipients","11":"EnvelopeV2","12":"RsvpEnvelopeV2","13":"Guests","14":"Review","15":"RSVPV2","16":"EventDetailBackV2","17":"EventDetailFrontV2","18":"DigitalCard","19":"EventDetailInsideV2","20":"PublicDigitalCard","21":"DigitalReview","22":"CardDetailPageRedesign","23":"Planning","24":"OnboardContainer","25":"Cards","26":"HomeSaveTheDate","27":"Dashboard","28":"GuestList","29":"WebsiteV3","30":"DashboardV5","31":"CardCustomizationFlowV2","32":"PreAuthChecklist","33":"ManagePagesRedesign","34":"ThemeDetail","35":"Onboard","36":"Website","37":"ProjectOrders","38":"ProjectDrafts","39":"GuestsV2","40":"PreAuthThemesV2","41":"Events","42":"CardProjects","43":"AccountSettings","44":"GuestHelp","45":"Pages","46":"DigitalCompletion","47":"Public","48":"Passcode","49":"Manage","50":"Login","51":"Feed","52":"TrackRsvpsContainer","53":"main"}[chunkId]||chunkId) + "." + {"0":"5390f35e","1":"83dc4b37","2":"e3ecbc67","3":"a79c0d38","4":"f73ba529","5":"5b14a928","6":"cddda038","7":"f353b325","8":"9cdbff21","9":"2845621e","10":"5f0b8e71","11":"c4b2fec0","12":"e8ab7067","13":"763e7f8c","14":"6bd027ef","15":"86e39950","16":"fc636c2c","17":"a0be64db","18":"6f84ba40","19":"87d72f6a","20":"83039b48","21":"1719ffa8","22":"144e77b1","23":"028805cb","24":"2d800ffa","25":"1d737007","26":"d4a1f679","27":"f731087e","28":"6fc48420","29":"f8269002","30":"3aa4b62d","31":"a1f0ae73","32":"37116a39","33":"453cf0f0","34":"8d0770b8","35":"014fe889","36":"0ccc158b","37":"4d49d04d","38":"73e2eae6","39":"58aaabab","40":"cda0f274","41":"3b04367e","42":"04992f96","43":"1d9562af","44":"3ebc08ab","45":"05d75b2f","46":"13088b1e","47":"8e00d486","48":"1380e8d9","49":"745e1352","50":"174eb67b","51":"c37a48d0","52":"7ddad98c","53":"ac657157","54":"3b8a08ca"}[chunkId] + ".chunk.js";
 		var timeout = setTimeout(onScriptComplete, 120000);
 		script.onerror = script.onload = onScriptComplete;
 		function onScriptComplete() {
 			// avoid mem leaks in IE.
 			script.onerror = script.onload = null;
 			clearTimeout(timeout);
 			var chunk = installedChunks[chunkId];
 			if(chunk !== 0) {
 				if(chunk) {
 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
 				}
 				installedChunks[chunkId] = undefined;
 			}
 		};
 		head.appendChild(script);

 		return promise;
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, {
 				configurable: false,
 				enumerable: true,
 				get: getter
 			});
 		}
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };



// WEBPACK FOOTER //
// webpack/bootstrap 5961e81d5dd95b10bab3